export * from './replace.directive';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/directives/replace/index.ts